<div class="viewer" (click)="close()">
  <button type="button" class="viewer-close" (click)="close(); $event.stopPropagation()">
    <ion-icon name="close-outline" aria-hidden="true" />
    <span class="visually-hidden">{{ "image-viewer.close" | translate }}</span>
  </button>
  <img class="viewer-image" [src]="src" [alt]="alt" (click)="$event.stopPropagation()" />
</div>
